<mat-form-field [appearance]="appearance" class="w-100">
  <mat-label>{{ label }}</mat-label>
  <input
    type="text"
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
    [placeholder]="placeholder"
    (blur)="_onTouched()" />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option[valueProperty]">
      {{ option[valueProperty] }}
    </mat-option>
  </mat-autocomplete>
  <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
  <button *ngIf="control.value && !control.disabled" matSuffix mat-icon-button aria-label="Clear" (click)="clear()">
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>
